export const LOW_METERED_PLAN_NAME = 'low_metered'
export const HIGH_METERED_PLAN_NAME = 'high_metered'

export const predefinedPlans = {
  [LOW_METERED_PLAN_NAME]: { name: LOW_METERED_PLAN_NAME, description: 'Standard', price: 49 },
  [HIGH_METERED_PLAN_NAME]: { name: HIGH_METERED_PLAN_NAME, description: 'Pro', price: 199 }
}
